import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RichtextContentModel } from '@libs/cms/models';
import { HtmlDataLinkDirective } from '@libs/shared/ui';
import { HeadlinesComponent } from '../../items';
import { ContentBaseComponent } from '../content-base.component';

@Component({
  selector: 'ui-richtext',
  templateUrl: './richtext.component.html',
  styleUrls: ['./richtext.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    HeadlinesComponent,
    HtmlDataLinkDirective,
  ],
})
export class RichtextComponent extends ContentBaseComponent<RichtextContentModel> {
}
